import React from 'react'
import styles from './MaterialInput.module.scss'

import {TextField, InputProps} from "@material-ui/core";
import clsx from "clsx";

interface MaterialInputProps {
    defaultValue?: string | number
    value?: string | number
    className?: string
    label?: string
    name: string
    id?: string
    type?: string
    error?: boolean
    helperText?: string | boolean
    inputProps?: InputProps
    children?: React.ReactNode
    select?: boolean
    onClick?: (e: React.MouseEvent<HTMLInputElement>) => void
    endAdornment?: any
    inputRef?: any
    multiline?: boolean
    rows?: number
    maxRows?: number
    disabled?: boolean
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void
    onTouchStartCapture?: (event: React.TouchEvent<HTMLDivElement>) => void
    onTouchEndCapture?: (event: React.TouchEvent<HTMLDivElement>) => void
    shrink?: boolean
}

const MaterialInput = ({ className, label, name, id, type, error, helperText, children, endAdornment, multiline, rows, onChange, inputProps, disabled, defaultValue, value, maxRows, shrink, inputRef, ...props }: MaterialInputProps) => {
    let inputPropsMerged: any = {
        endAdornment: endAdornment,
        style: { borderRadius: '0.5rem' },
        ...(inputProps || {})
    }

    const shrinkLabel = shrink ? { shrink: !!value || !!defaultValue } : {}

    let inputLabelProps = {
        ...shrinkLabel
    }

    return (
        <TextField
            {...props}
            disabled={disabled}
            onChange={onChange}
            className={clsx(className, styles.inputTextField, styles.styledInput)}
            variant="outlined"
            size="medium"
            InputProps={inputPropsMerged}
            InputLabelProps={inputLabelProps}
            label={label}
            id={id}
            name={name}
            type={type}
            error={error}
            helperText={helperText}
            multiline={multiline}
            minRows={rows}
            maxRows={maxRows}
            defaultValue={defaultValue}
            value={value}
            inputRef={inputRef}
        >{children}</TextField>
    )
}

export default MaterialInput
